import { useEffect, useRef } from "react";

/**
 * Adds `has-bg` to the element (or its closest `ancestor`) once it is within `margin` of the viewport, so a heavy
 * CSS background-image isn't downloaded until it's about to be seen.
 */
export default function useLazyBackground(ancestor, margin = "500px") {
  const ref = useRef(null);
  useEffect(() => {
    const watched = ref.current;
    const el = (ancestor && watched && watched.closest(ancestor)) || watched;
    if (!el) return undefined;
    if (typeof IntersectionObserver === "undefined") {
      el.classList.add("has-bg");
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("has-bg");
          observer.disconnect();
        }
      },
      { rootMargin: margin }
    );
    observer.observe(watched);
    return () => observer.disconnect();
  }, [ancestor, margin]);
  return ref;
}
